/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line
(function() {
  document.addEventListener("DOMContentLoaded", function () {
    // Example: Scroll to top button
    const scrollBtn = document.querySelector("[data-scroll-top-button]");
    if (scrollBtn) {
      scrollBtn.addEventListener("click", () => {
        window.scrollTo({ top: 0, behavior: "smooth" });
      });
    }

    // Add more non-critical features here
  });
})();
window.addEventListener("load", function () {
  const script = document.createElement("script");
  script.src = "https://example.com/some-heavy-app.js";
  script.defer = true;
  document.body.appendChild(script);
});







  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
